import {GetSeferData} from "SeferPetach/GetData";

//#region Application Content
export async function getApplicationContentList(obj) {
    const args = obj;
    var payload = await GetSeferData("gaclist", args);
    return (payload);
}
//#endregion